import React, {forwardRef, useImperativeHandle, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'antd';

import JobLogInfo from "@/page/admin/JobsPage/JobLogsPage/JobLogInfo";

const JobLogInfoModal = forwardRef(({modalTitle}, ref) => {

    const [visible, setVisible] = useState(false);
    const [jobLogId, setJobLogId] = useState(null);

    function showModal(jobLogId) {
        setVisible(true);
        setJobLogId(jobLogId);
    }

    function closeModal() {
        setVisible(false);
        setJobLogId(null);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));


    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            width={680}
            title={modalTitle}
            visible={visible}
            onCancel={closeModal}
            onOk={closeModal}
        >
            <JobLogInfo jobLogId={jobLogId} />
        </Modal>
    );
});

JobLogInfoModal.displayName = 'JobLogInfoModal';

JobLogInfoModal.propTypes = {
    modalTitle: PropTypes.string,
};

export default JobLogInfoModal;
